'use client';
import { ReactNode } from 'react';
import './EmptyState.css';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import { Variant } from '../../core/ui';

interface EmptyStateProps {
	title?: string;
	description: string;
	icon?: string;
	variant?: Variant;
	className?: string;
	children?: ReactNode;
}

const EmptyState = ({
	title,
	description,
	icon,
	variant = 'primary',
	className,
	children,
}: EmptyStateProps) => {
	return (
		<div
			className={`empty-state${
				icon != null ? ' empty-state--icon' : ''
			} empty-state--${variant}${className != null ? ' ' + className : ''}`}
		>
			{icon && (
				<div className='empty-state__icon'>
					<SlIcon name={icon} />
				</div>
			)}
			{title && <div className='empty-state__title'>{title}</div>}
			<div className='empty-state__description'>{description}</div>
			{children && <div className='empty-state__content'>{children}</div>}
		</div>
	);
};

export { EmptyState };
